import VueElementLoading from "vue-element-loading";
import {ToggleButton} from "vue-js-toggle-button";

Vue.component("loading", VueElementLoading);
Vue.component('cityinput', require('../components/front/CityInput.vue').default);
Vue.component('datepicker', require('../components/front/DatePicker.vue').default);
Vue.component("stripe-form",require("../components/front/pay/StripeForm").default)
Vue.component("main-slider",require("./../components/front/home/MainSlider.vue").default)
Vue.component("ads-slider",require("./../components/front/home/AdsSlider.vue").default)
Vue.component("take-chance",require("./../components/front/home/TakeChance.vue").default)
Vue.component("register-modal",require("./../components/front/home/register-modal.vue").default)
// Vue.component("chat", require("./../components/front/chat/Chat.vue").default);
Vue.component("auth", require("./../components/front/auth/Auth.vue").default);
Vue.component("forget-password",require("./../components/front/auth/ForgetPassword.vue").default)
Vue.component("reset-password",require("./../components/front/auth/ResetPassword.vue").default)
Vue.component("matches-list",require("./../components/front/matches/MatchesList.vue").default)
Vue.component("blocked-users-list",require("./../components/front/blocked-users/BlockedUsersList.vue").default)
Vue.component("suggested-users-list",require("./../components/front/suggested-users/SuggestedUsersList.vue").default)
Vue.component("chat-container",require("../components/front/chats/ChatContainer.vue").default)
Vue.component("place-input",require("../components/front/PlaceInput").default)
Vue.component("create-chat",require("../components/front/chats/CreateChat").default)
Vue.component("message-modal",require("../components/front/chats/MessageModal").default)
Vue.component("chat-requests",require("../components/front/chats/ChatRequests.vue").default)
Vue.component("avatar",require("../components/front/user/Avatar").default)
Vue.component("videos-preview",require("../components/front/user/VideosPreview.vue").default)
Vue.component("photos-preview",require("../components/front/user/PhotosPreview.vue").default)
Vue.component("similar-users",require("../components/front/user/SimilarUsers.vue").default)
Vue.component("upload-photo",require("../components/front/user/UploadPhoto.vue").default)
Vue.component("upload-video",require("../components/front/user/UploadVideo.vue").default)
Vue.component("start-chat",require("../components/front/user/StartChat.vue").default)
Vue.component("notifications-container",require("../components/front/notifications/NotificationsContainer.vue").default)
Vue.component("user-activities",require("../components/front/UserActivities.vue").default)
Vue.component("tell-your-story",require("../components/front/story/TellYourStory").default)
Vue.component("local-time", require("../components/LocalTime").default);
Vue.component('ToggleButton', ToggleButton);
Vue.component("v-update-profile-cover",require("../components/front/update-profile-cover").default)

Vue.component("v-select-favorite-countries",require("../components/front/select-favorite-countries").default)
Vue.component("v-select-home-town",require("../components/front/select-home-town").default)
Vue.component("v-match-seeker",require("./components/match-seeker" ).default)
Vue.component("v-loading",require("./components/loading").default)
Vue.component("v-multiselect",require("vue-multiselect").default)
Vue.component("v-select",require("vue-select").default)
Vue.component("v-messenger",require("./components/messenger").default)
Vue.component("v-header-chats",require("./components/header-chats").default)
Vue.component("v-header-notifications",require("./components/header-notifications").default)
Vue.component("v-register",require("./components/register").default)
Vue.component("v-avatar-cropper",require("vue-avatar-cropper").default)
Vue.component("v-select-avatar",require("./components/select-avatar").default)
Vue.component("v-date-picker",require("vuejs-datepicker").default)

